import React from 'react';
import { Main } from './components/containers/Main';

const ViewCRM = () => <Main />;

export default ViewCRM;
